import { Demographics } from './Demographics';
import { LookupsFetcher } from '../common';
import { ContainerInputProps } from '@/app/features/products/common/components/input-props';
import { useDataStore } from '@/app/core/components/step-wizard';
import { useEffect, useState } from 'react';
import { demographicsSchemaValidator } from '@ssar-app/domain';

export const DemographicsContainer = (props: ContainerInputProps) => {
  const [subCode, setSubCode] = useState<string>('');
  const { keys } = props;
  const { data } = useDataStore();

  useEffect(() => {
    if (data?.subCode !== '') {
      setSubCode(data?.subCode);
    }
  }, [data?.subCode]);

  return (
    <>
      {subCode !== '' && (
        <LookupsFetcher
          subCode={subCode}
          onSuccess={(lookupsManager, isLoading) => {
            return (
              <Demographics
                stepKey={keys}
                moduleProps={{
                  lookupsManager: lookupsManager,
                  isLoading: isLoading,
                }}
                validator={demographicsSchemaValidator}
              />
            );
          }}
          onError={(error) => {
            console.error(error);
          }}
        />
      )}
    </>
  );
};
